var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanding4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 300",
    width: 900,
    height: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 300,
    fill: "#F7F2D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 190L13.7 197.8C27.3 205.7 54.7 221.3 82 226.7C109.3 232 136.7 227 163.8 224.8C191 222.7 218 223.3 245.2 228.2C272.3 233 299.7 242 327 242.8C354.3 243.7 381.7 236.3 409 225.8C436.3 215.3 463.7 201.7 491 203.2C518.3 204.7 545.7 221.3 573 233.3C600.3 245.3 627.7 252.7 654.8 255C682 257.3 709 254.7 736.2 254C763.3 253.3 790.7 254.7 818 250.3C845.3 246 872.7 236 886.3 231L900 226L900 301L886.3 301C872.7 301 845.3 301 818 301C790.7 301 763.3 301 736.2 301C709 301 682 301 654.8 301C627.7 301 600.3 301 573 301C545.7 301 518.3 301 491 301C463.7 301 436.3 301 409 301C381.7 301 354.3 301 327 301C299.7 301 272.3 301 245.2 301C218 301 191 301 163.8 301C136.7 301 109.3 301 82 301C54.7 301 27.3 301 13.7 301L0 301Z",
    fill: "#B5916B",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanding4);
export default __webpack_public_path__ + "static/media/landing-4.5f7f9429a39402977424bb496792a59e.svg";
export { ForwardRef as ReactComponent };